import { OrdersApiRemoteService } from '../../Services/api/orders/orders-service'
import { IPickingFlowResponse, IOrdersListPayload } from '../../Services/api/orders/orders.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class PickingFlowUseCase
implements IFormUsecase<Partial<IOrdersListPayload>, IPickingFlowResponse[]> {
  constructor (private readonly ServiceOrdersApi: OrdersApiRemoteService) {}
    

  public async handle (payload?: Partial<IOrdersListPayload>): Promise<Result<IPickingFlowResponse[]>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ServiceOrdersApi.pickingFlow(payload)

      if (response.isFailure) {
        return response
      }

      const pickingFlow = response.getValue()

      if(!pickingFlow) return response

    
      return Result.ok(pickingFlow)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
